module.exports = __webpack_public_path__ + "img/win_7.8afa8268.png";